var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-client-table',{attrs:{"data":_vm.employers,"columns":_vm.columns,"options":_vm.options},scopedSlots:_vm._u([{key:"amfCode",fn:function(ref){
var row = ref.row;
return [_c('div',[_c('a',{staticClass:"text-decoration-underline",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.showEmployer(row)}}},[_vm._v(_vm._s(row.amfCode))])])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f431eda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/edi/EmployerEdiList.vue
// module id = null
// module chunks = 